/**
 * แปลงวันที่จากรูปแบบไทย (dd/mm/yyyy) เป็น ISO (yyyy-MM-dd)
 * @param thaiDate วันที่ในรูปแบบไทย (dd/mm/yyyy)
 * @returns วันที่ในรูปแบบ ISO (yyyy-MM-dd)
 */
export const convertThaiDateToISO = (thaiDate: string): string => {
  if (!thaiDate) return '';
  
  const parts = thaiDate.split("/");
  if (parts.length === 3) {
    // ปรับปรุงปีให้เป็นค.ศ.
    const year = parseInt(parts[2]) - 543;
    return `${year}-${parts[1]}-${parts[0]}`;
  }
  console.log(`Thai ${thaiDate}`);
  return thaiDate;
};

/**
 * แปลงวันที่จาก ISO (yyyy-MM-dd) เป็นรูปแบบไทย (dd/mm/yyyy)
 * @param isoDate วันที่ในรูปแบบ ISO (yyyy-MM-dd)
 * @returns วันที่ในรูปแบบไทย (dd/mm/yyyy)
 */
export const convertISODateToThai = (isoDate: string): string => {
  if (!isoDate) return '';
  
  const parts = isoDate.split("-");
  if (parts.length === 3) {
    // ปรับปรุงปีให้เป็นพ.ศ.
    const year = parseInt(parts[0]) + 543;
    return `${parts[2]}/${parts[1]}/${year}`;
  }
  return isoDate;
}; 